import { render } from "./ForumCategoryDelete.vue?vue&type=template&id=676969aa&scoped=true"
import script from "./ForumCategoryDelete.vue?vue&type=script&lang=js"
export * from "./ForumCategoryDelete.vue?vue&type=script&lang=js"

import "./ForumCategoryDelete.vue?vue&type=style&index=0&id=676969aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-676969aa"]])

export default __exports__